import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import {
  Col,
  Container,
  NavItem,
  Row,
  TabContent,
  TabPane
} from "reactstrap";
import classNames from "classnames";
import { getOneEntity } from "http/fundLync/entityAndAddress.helper";
import "./style.scss";
//Import Breadcrumb
import BorrowingProfile from "./borrowingProfile";
import Directors from "./directors";
import EntityDetails from "./entityDetails";
import Partners from "./partners";
import Proprietors from "./proprietor";
import ShareholdingPatterns from "./shareholdingPattern";

const AddEntityDetails = (props) => {
  //meta title
  document.title = "Entity Details | FundLync";
  const urlParams = new URLSearchParams(window.location.search);
  const encodedEntityId = urlParams.get("id");
  const entityId = atob(encodedEntityId);
  const encodedId = urlParams.get("tab");
  const decodedId = atob(encodedId);
  const [activeTabVartical, setoggleTabVertical] = useState(1);
  const [passedStepsVertical, setPassedStepsVertical] = useState([1]);
  const [entityDetail, setEntityDetail] = useState([]);

  useEffect(() => {
    toggleTabVertical(+decodedId);
  }, [decodedId]);

  useEffect(() => {
    getOneEntity({ entityId })
      .then((response) => {
        if (response) {
          setEntityDetail(response.data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const constituition = entityDetail[0]?.entityConstitution;

  function toggleTabVertical(tab) {
    if (activeTabVartical !== tab) {
      const modifiedSteps = [...passedStepsVertical, tab];
      if (constituition == "Proprietorship") {
        if (tab >= 1 && tab <= 3) {
          setoggleTabVertical(tab);
          setPassedStepsVertical(modifiedSteps);
        }
      } else {
        if (tab >= 1 && tab <= 4) {
          setoggleTabVertical(tab);
          setPassedStepsVertical(modifiedSteps);
        }
      }
    }
  }

  return (
    <div className="page-content">
        <Container fluid>
          <Col sm={4}>
            <h4>{entityDetail[0]?.entityName}</h4>
          </Col>
          <div className="vertical-scroll">
            <Row>
              <Col lg="12">
                <div className="wizard clearfix">
                  <div className="steps clearfix">
                    <ul>
                      <NavItem
                        className={classNames({
                          current: activeTabVartical === 1,
                        })}
                      >
                        <NavLink
                          className={classNames({
                            active: activeTabVartical === 1,
                          })}
                          onClick={(e) => {
                            e.preventDefault();
                            toggleTabVertical(1);
                          }}
                          disabled={!(passedStepsVertical || []).includes(1)}
                        >
                          <div className="d-flex">
                            <span className="number">1</span>
                            <div className="formWizardText">
                              {" "}
                              Entity Details
                            </div>
                          </div>
                        </NavLink>
                      </NavItem>

                      {constituition == "Public Limited Company" ||
                      constituition == "Private Limited Company" ? (
                        <NavItem
                          className={classNames({
                            current: activeTabVartical === 2,
                          })}
                        >
                          <NavLink
                            className={
                              (classNames({
                                active: activeTabVartical === 2,
                              }),
                              "done")
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              toggleTabVertical(2);
                            }}
                            disabled={!(passedStepsVertical || []).includes(2)}
                          >
                            <div className="d-flex">
                              <span className="number">2</span>
                              <div className="formWizardText">
                                Directors and Promoters
                              </div>
                            </div>
                          </NavLink>
                        </NavItem>
                      ) : null}

                      {constituition == "Limited Liability Partnership" ||
                      constituition == "Partnership" ? (
                        <NavItem
                          className={classNames({
                            current: activeTabVartical === 2,
                          })}
                        >
                          <NavLink
                            className={
                              (classNames({
                                active: activeTabVartical === 2,
                              }),
                              "done")
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              toggleTabVertical(2);
                            }}
                            disabled={!(passedStepsVertical || []).includes(2)}
                          >
                            <div className="d-flex">
                              <span className="number">2</span>
                              <div className="formWizardText">Partners</div>
                            </div>
                          </NavLink>
                        </NavItem>
                      ) : null}

                      {constituition == "Public Limited Company" ||
                      constituition == "Private Limited Company" ||
                      constituition == "Limited Liability Partnership" ||
                      constituition == "Partnership" ? (
                        <NavItem
                          className={classNames({
                            current: activeTabVartical === 3,
                          })}
                        >
                          <NavLink
                            className={
                              (classNames({
                                active: activeTabVartical === 3,
                              }),
                              "done")
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              toggleTabVertical(3);
                            }}
                            disabled={!(passedStepsVertical || []).includes(3)}
                          >
                            <div className="d-flex">
                              <span className="number">3</span>
                              <div className="formWizardText">
                                Shareholding <br /> Pattern
                              </div>
                            </div>
                          </NavLink>
                        </NavItem>
                      ) : null}

                      {constituition == "Proprietorship" ? (
                        <NavItem
                          className={classNames({
                            current: activeTabVartical === 2,
                          })}
                        >
                          <NavLink
                            className={
                              (classNames({
                                active: activeTabVartical === 2,
                              }),
                              "done")
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              toggleTabVertical(2);
                            }}
                            disabled={!(passedStepsVertical || []).includes(2)}
                          >
                            <div className="d-flex">
                              <span className="number">2</span>
                              <div className="formWizardText">
                                Proprietor Details
                              </div>
                            </div>
                          </NavLink>
                        </NavItem>
                      ) : null}

                      {constituition == "Public Limited Company" ||
                      constituition == "Private Limited Company" ||
                      constituition == "Limited Liability Partnership" ||
                      constituition == "Partnership" ? (
                        <NavItem
                          className={classNames({
                            current: activeTabVartical === 4,
                          })}
                        >
                          <NavLink
                            className={classNames({
                              active: activeTabVartical === 4,
                            })}
                            onClick={(e) => {
                              e.preventDefault();
                              toggleTabVertical(4);
                            }}
                            disabled={!(passedStepsVertical || []).includes(4)}
                          >
                            <div className="d-flex align-items-center">
                              <span className="number">4</span>{" "}
                              <div className="formWizardText">
                                Borrowing Profile
                              </div>
                            </div>
                          </NavLink>
                        </NavItem>
                      ) : null}
                      {constituition == "Proprietorship" ? (
                        <NavItem
                          className={classNames({
                            current: activeTabVartical === 3,
                          })}
                        >
                          <NavLink
                            className={classNames({
                              active: activeTabVartical === 3,
                            })}
                            onClick={(e) => {
                              e.preventDefault();
                              toggleTabVertical(3);
                            }}
                            disabled={!(passedStepsVertical || []).includes(3)}
                          >
                            <div className="d-flex align-items-center">
                              <span className="number">3</span>{" "}
                              <div className="formWizardText">
                                Borrowing Profile
                              </div>
                            </div>
                          </NavLink>
                        </NavItem>
                      ) : null}
                    </ul>
                  </div>
                  <div className="content clearfix">
                    <TabContent activeTab={activeTabVartical} className="body">
                      <TabPane tabId={1}>
                        <EntityDetails />
                      </TabPane>
                      {constituition == "Public Limited Company" ||
                      constituition == "Private Limited Company" ? (
                        <TabPane tabId={2}>
                          <Directors />
                        </TabPane>
                      ) : null}

                      {constituition == "Limited Liability Partnership" ||
                      constituition == "Partnership" ? (
                        <TabPane tabId={2}>
                          <Partners />
                        </TabPane>
                      ) : null}
                      {constituition == "Public Limited Company" ||
                      constituition == "Private Limited Company" ||
                      constituition == "Limited Liability Partnership" ||
                      constituition == "Partnership" ? (
                        <TabPane tabId={3}>
                          <ShareholdingPatterns />
                        </TabPane>
                      ) : null}

                      {constituition == "Proprietorship" ? (
                        <TabPane tabId={2}>
                          <Proprietors />
                        </TabPane>
                      ) : null}

                      {constituition == "Proprietorship" ? (
                        <TabPane tabId={3}>
                          <BorrowingProfile />
                        </TabPane>
                      ) : null}

                      {/* {constituition == "Public Limited Company" ||
                      constituition == "Private Limited Company" ? ( */}
                      <TabPane tabId={4}>
                        <BorrowingProfile />
                      </TabPane>
                      {/* ) : null} */}
                    </TabContent>
                  </div>
                  <div className="actions clearfix">
                    <ul>
                      <li
                        className={
                          activeTabVartical === 1
                            ? "previous disabled"
                            : "previous"
                        }
                      >
                        <Link
                          to="#"
                          onClick={(e) => {
                            e.preventDefault();
                            toggleTabVertical(activeTabVartical - 1);
                          }}
                        >
                          Previous
                        </Link>
                      </li>

                      {constituition == "Proprietorship" ? (
                        <li
                          className={
                            activeTabVartical === 3 ? "next disabled" : "next"
                          }
                        >
                          <Link
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              toggleTabVertical(activeTabVartical + 1);
                            }}
                          >
                            Next
                          </Link>
                        </li>
                      ) : (
                        <li
                          className={
                            activeTabVartical === 4 ? "next disabled" : "next"
                          }
                        >
                          <Link
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              toggleTabVertical(activeTabVartical + 1);
                            }}
                          >
                            Next
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
                {/* </CardBody>
                </Card> */}
              </Col>
            </Row>
          </div>
        </Container>
      </div>
  );
};

export default AddEntityDetails;
